module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qleg4-45ca3b3e26d759fe894acf212515fcac.jpg";